
(() => {
  const init = root => {
    if (root.dataset.collectionFiltersReady) return;
    const sidebar = root.querySelector('[data-collection-filter-sidebar]');
    const dialog = root.querySelector('[data-collection-filter-dialog]');
    const trigger = root.querySelector('[data-collection-filter-open]');
    const home = root.querySelector('[data-collection-filter-home]');
    const form = root.querySelector('[data-collection-filter-form]');
    if (!sidebar || !dialog || !trigger || !home || !form) return;
    root.dataset.collectionFiltersReady = 'true';
    const media = window.matchMedia('(max-width: 989px)');
    const baseline = [...form.querySelectorAll('[data-current-filter-tag]')].map(input => input.value);
    const selectedTags = new Set(baseline);
    const links = [...form.querySelectorAll('[data-collection-filter-tag] a')];
    const syncTags = () => links.forEach(link => {
      const active = selectedTags.has(link.closest('[data-collection-filter-tag]').dataset.collectionFilterTag);
      link.closest('li').classList.toggle('is-active', active);
      if (media.matches) {
        link.setAttribute('role', 'checkbox');
        link.setAttribute('aria-checked', String(active));
      } else {
        link.removeAttribute('role');
        link.removeAttribute('aria-checked');
      }
    });
    const reset = () => {
      form.reset();
      selectedTags.clear();
      baseline.forEach(tag => selectedTags.add(tag));
      syncTags();
    };
    const close = () => { if (dialog.open) dialog.close(); };
    const syncLayout = () => {
      close();
      if (media.matches) dialog.querySelector('[data-collection-filter-body]').append(sidebar);
      else home.after(sidebar);
      reset();
    };
    trigger.addEventListener('click', () => {
      if (!media.matches) return;
      reset();
      dialog.showModal();
      document.documentElement.classList.add('collection-filters-open');
    });
    dialog.querySelector('[data-collection-filter-close]').addEventListener('click', close);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('collection-filters-open');
      if (media.matches) trigger.focus();
    });
    links.forEach(link => {
      const toggle = event => {
        if (!media.matches) {
          const url = new URL(link.href, location.origin);
          url.search = location.search;
          url.searchParams.delete('page');
          link.href = url.pathname + url.search;
          return;
        }
        event.preventDefault();
        const tag = link.closest('[data-collection-filter-tag]').dataset.collectionFilterTag;
        if (selectedTags.has(tag)) selectedTags.delete(tag); else selectedTags.add(tag);
        syncTags();
      };
      link.addEventListener('click', toggle);
      link.addEventListener('keydown', event => { if (event.key === ' ') toggle(event); });
    });
    form.addEventListener('submit', event => {
      event.preventDefault();
      const url = new URL(form.dataset.collectionUrl, location.origin);
      if (selectedTags.size) url.pathname += '/' + [...selectedTags].map(encodeURIComponent).join('+');
      for (const [key, value] of new FormData(form)) {
        if (typeof value === 'string' && value.trim() !== '') url.searchParams.append(key, value);
      }
      location.assign(url.pathname + url.search + '#CollectionProducts');
    });
    media.addEventListener('change', syncLayout);
    const cleanup = event => {
      if (!event.target.contains(root)) return;
      close();
      media.removeEventListener('change', syncLayout);
      document.removeEventListener('shopify:section:unload', cleanup);
    };
    document.addEventListener('shopify:section:unload', cleanup);
    syncLayout();
  };
  const scan = () => document.querySelectorAll('.collection-main[data-paw-shelf]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once:true}); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
